import type { ReactNode } from 'react'
import { cn } from '@/utils/cn'

type Props = {
  children: ReactNode
  className?: string
}

export function KpiCardGrid({ children, className }: Props) {
  return (
    <div
      className={cn(
        'kpi-card-grid grid w-full items-stretch gap-3 overflow-visible py-1 sm:gap-4 sm:py-2',
        className,
      )}
    >
      {children}
    </div>
  )
}
